<template>
  <form :action="url" class="dropzone" :id="id"></form>
</template>

<script>
  var Dropzone = require('dropzone')
  Dropzone.autoDiscover = false

  export default {
    props: {
      id: {
        type: String,
        required: true
      },
      url: {
        type: String,
        required: true
      },
      clickable: {
        type: Boolean,
        default: true
      },
      acceptedFileTypes: {
        type: String
      },
      thumbnailHeight: {
        type: Number,
        default: 200
      },
      thumbnailWidth: {
        type: Number,
        default: 200
      },
      showRemoveLink: {
        type: Boolean,
        default: true
      },
      maxFileSizeInMB: {
        type: Number,
        default: 70
      },
      maxThumbnailFilesize: {
        type: Number,
        default: 70
      },
      maxNumberOfFiles: {
        type: Number,
        default: 1
      },
      autoProcessQueue: {
        type: Boolean,
        default: true
      },
      dictDefaultMessage: {
        type: String,
        default: '<i class="fa fa-cloud-upload fa-2x" aria-hidden="true"></i><br>Carregar ficheiro aqui'
      },
      dictRemoveFile: {
        type: String,
        default: 'Remover'
      },
      dictFileTooBig: {
        type: String,
        default: 'Ficheiro demasiado grande ({{filesize}}MiB). Max: {{maxFilesize}}MiB.'
      },
      dictInvalidFileType: {
        type: String,
        default: 'Tipo de ficheiro inválido.'
      },
      dictCancelUpload: {
        type: String,
        default: 'Cancelar upload'
      },
      dictCancelUploadConfirmation: {
        type: String,
        default: 'Tem a certeza que quer cancelar o upload?'
      },
      dictMaxFilesExceeded: {
        type: String,
        default: 'Não pode carregar mais ficheiros'
      },
      useCustomDropzoneOptions: {
        type: Boolean,
        default: false
      },
      dropzoneOptions: {
        type: Object
      }
    },

    // dictDefaultMessage: "Drop files here to upload",
    // dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
    // dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
    // dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
    // dictInvalidFileType: "You can't upload files of this type.",
    // dictResponseError: "Server responded with {{statusCode}} code.",
    // dictCancelUpload: "Cancel upload",
    // dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
    // dictRemoveFile: "Remove file",
    // dictRemoveFileConfirmation: null,
    // dictMaxFilesExceeded: "You can not upload any more files.",

    events: {
      removeAllFiles: function () {
        this.dropzone.removeAllFiles(true)
      },
      processQueue: function () {
        this.dropzone.processQueue()
      }
    },
    mounted () {
      var element = document.getElementById(this.id)
      if (!element) {
        element = this.$el
      }
      if (!this.useCustomDropzoneOptions) {
        this.dropzone = new Dropzone(element, {
          clickable: this.clickable,
          thumbnailWidth: this.thumbnailWidth,
          thumbnailHeight: this.thumbnailHeight,
          maxFiles: this.maxNumberOfFiles,
          maxFilesize: this.maxFileSizeInMB,
          maxThumbnailFilesize: this.maxThumbnailFilesize,
          dictRemoveFile: this.dictRemoveFile,
          addRemoveLinks: this.showRemoveLink,
          acceptedFiles: this.acceptedFileTypes,
          autoProcessQueue: this.autoProcessQueue,
          dictDefaultMessage: this.dictDefaultMessage,
          dictFileTooBig: this.dictFileTooBig,
          dictInvalidFileType: this.dictInvalidFileType,
          dictCancelUpload: this.dictCancelUpload,
          dictCancelUploadConfirmation: this.dictCancelUploadConfirmation,
          dictMaxFilesExceeded: this.dictMaxFilesExceeded,
          previewTemplate: '<div class="dz-preview dz-file-preview">  <div class="dz-image" style="width:' + this.thumbnailWidth + 'px;height:' + this.thumbnailHeight + 'px"><img data-dz-thumbnail /></div>  <div class="dz-details">    <div class="dz-size"><span data-dz-size></span></div>    <div class="dz-filename"><span data-dz-name></span></div>  </div>  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>  <div class="dz-error-message"><span data-dz-errormessage></span></div>  <div class="dz-success-mark"> <span class="fa-stack fa-lg fa-coach-preview"> <i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-check fa-stack-1x"></i> </span> </div>  <div class="dz-error-mark"> <span class="fa-stack fa-lg fa-coach-preview"> <i class="fa fa-circle fa-stack-2x"></i> <i class="fa fa-exclamation fa-stack-1x"></i> </span> </div></div>'
        })
      } else {
        this.dropzone = new Dropzone(element, this.dropzoneOptions)
      }

      // Handle the dropzone events
      var vm = this
      this.dropzone.on('addedfile', function (file) {
        vm.$emit('vdropzone-fileAdded', file)
      })

      this.dropzone.on('maxfilesexceeded', function (file) {
        this.removeFile(file)
        vm.$emit('vdropzone-maxfilesexceeded', file)
      })

      this.dropzone.on('removedfile', function (file) {
        vm.$emit('vdropzone-removedfile', file)
      })

      this.dropzone.on('success', function (file, response) {
        setTimeout(() => {
          let success = this.element.querySelector('.dz-success-mark')
          if (success) {
            success.classList.add('dropzone-hidden')
          }
        }, 3000)
        vm.$emit('vdropzone-success', file, response)
      })

      this.dropzone.on('error', function (file, error, xhr) {
        vm.$emit('vdropzone-error', file, error, xhr)
      })
    }
  }

</script>

<style>
  @import url('~dropzone/dist/dropzone.css');
  @import 'https://fonts.googleapis.com/css?family=Roboto';

  html{
    background-color: #F9F9F9;
  }

  .dropzone{
    /*border: 2px solid #E5E5E5;*/
    border: 1px solid #dbdbdb;
    border-radius: 3px;
    box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
    font-family: 'Roboto', sans-serif;
    color: #777;
    transition: background-color .2s linear;
    background-image: url("~assets/images/ps-neutral.png");
  }

  .marginless-dropzone {
    padding: 0;
  }

  .dropzone:hover{
    /*background-color: #F6F6F6;*/
    border-color: #b5b5b5;
  }

  .dropzone i {
    color: #CCC;
  }

  .marginless-dropzone .dz-preview {
    margin: 1px auto;
  }

  .dropzone .dz-preview {
    background-image: url("~assets/images/ps-neutral.png") !important;
    overflow: hidden;
  }

  .dropzone .dz-preview .dz-image {
    border-radius: 0px;
  }

  .dropzone .dz-preview:hover .dz-image img{
    transform: none;
    -webkit-filter: none;
  }

  .dropzone .dz-preview .dz-details{
    bottom: 0px;
    top: 0px;
    color: white;
    background-color: rgba(37, 148, 139, 0.8);
    transition: opacity .2s linear;
    text-align: left;
  }
  .dropzone .dz-preview .dz-details .dz-filename span, .dropzone .dz-preview .dz-details .dz-size span {
    background-color: transparent;
  }
  .dropzone .dz-preview .dz-details .dz-filename:not(:hover) span{
    border: none;
  }

  .dropzone .dz-preview .dz-details .dz-filename:hover span{
    background-color: transparent;
    border: none;
  }

  .dropzone .dz-preview .dz-remove{
    position: absolute;
    z-index: 30;
    color: white;
    margin-left: 15px;
    padding: 10px;
    top: inherit;
    bottom: 15px;
    border: 2px white solid;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: 800;
    letter-spacing: 1.1px;
    opacity: 0;
  }

  .dropzone .dz-preview:hover .dz-remove {
    opacity: 1;
  }

  .dropzone .dz-preview .dz-success-mark, .dropzone .dz-preview .dz-error-mark {
    margin-left: -35px;
    margin-top: -40px;
  }

  .dropzone .dz-preview .dz-success-mark i, .dropzone .dz-preview .dz-error-mark i {
    color: white;
    width: 70px;
    height: 70px;
  }

  .dropzone-hidden {
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// DropzoneForm.vue?29a3cf78